import { render, staticRenderFns } from "./headTip.vue?vue&type=template&id=f0401544&scoped=true&"
import script from "./headTip.vue?vue&type=script&lang=js&"
export * from "./headTip.vue?vue&type=script&lang=js&"
import style0 from "./headTip.vue?vue&type=style&index=0&id=f0401544&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0401544",
  null
  
)

export default component.exports